(
    function (skyward, $, undefined)
    {
        skyward.employeeaccess = skyward.employeeaccess || {};

        skyward.employeeaccess.displayOnlineFormsPopup = function ()
        {
            var button = $(this);
            var EmployeeID = button.data().id;
            var OnlineFormIDs = button.data().onlineformids;

            var buildPopup = function ()
            {
                return $.ajax({
                    url: skyward.global.virtualDir + "OnlineForm/OnlineForm/GetEmployeeAccessOnlineFormsPopup/",
                    type: "POST",
                    dataType: "viewparthtml",
                    data: { EmployeeID: EmployeeID, OnlineFormIDsOverride: JSON.stringify(OnlineFormIDs) }
                });
            };

            var popupTitle = "Online Forms";
            skyward.modalLayer.showDialog(popupTitle, buildPopup, { text: "Close", icon: "Close" }, { anchorTo: button });
        };

        var events =
        {
            'displayOnlineFormsPopup': skyward.employeeaccess.displayOnlineFormsPopup
        };
        skyward.events.registerEvents('employeeaccess', events);

    }(window.skyward = window.skyward || {}, window.jQuery)
);